import { Box, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { FC, useContext } from 'react';
import IngredientRow from './IngredientRow';
import { RecipeComponent } from '../../../../app/services/api/generated';
import { useTranslation } from 'react-i18next';
import { UserContext } from '../../../../components/shared/useUser';
import { Section } from '../../../../components/ui/Section';
import { TableHeader } from '../../../../components/forms/TableHeader';
import { Pill } from '../../../../components/shared/Pill';

type Props = {
  ingredients: RecipeComponent[];
  onEdit: () => void;
  currencyCode?: string;
}

const RecipeIngredients: FC<Props> = ({ ingredients, onEdit, currencyCode }) => {
  const { hasPermissionTo } = useContext(UserContext);
  const { t } = useTranslation('recipe');

  return (
    <Box sx={{ p: 5 }}>
      <Box display='flex'
        flexDirection='row'
        justifyContent='space-between'
        alignItems='center'
      >
        <Typography variant='textLG'
          alignSelf='flex-start'>
          {t('recipeComponents')}
        </Typography>
        {hasPermissionTo(['RecipeWrite']) && <Button size='md'
          onClick={onEdit}
          sx={{ alignSelf: 'flex-end', mb: 3 }}>{t('editRecipe')}</Button>}
      </Box>
      {ingredients?.length === 0 ? (
        <Typography variant='textMD'>
          {t('noComponents')}
        </Typography>
      ) : (
        <Section>
          <TableHeader>
            {t('recipeComponents')}
            {ingredients?.length > 0 && <Pill text={`${ingredients?.length} ${t('recipeComponents')}`}></Pill>}
          </TableHeader>
          <TableContainer sx={{ borderBottomLeftRadius: '12px', borderBottomRightRadius: '12px' }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>{t('thumbnailImage')}</TableCell>
                  <TableCell>{t('sku')}</TableCell>
                  <TableCell>{t('itemName')}</TableCell>
                  <TableCell>{t('netWeightInput')}</TableCell>
                  <TableCell>{t('quantityInput')}</TableCell>
                  <TableCell>{t('costPriceInput')}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {ingredients.map((item) => (
                  <IngredientRow
                    key={item.componentId}
                    item={item}
                    currencyCode={currencyCode} />
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Section>
      )
      }
    </Box>
  );
};

export default RecipeIngredients;